import { clone } from 'ramda';
import { EOfferType, IJsonQuery } from './types';
import { offerTypeFromJsonQuery, isSuburban } from '../category';
import { setTerm } from './helpers';
import { selectOfferType } from './selectOfferType';

export function setVillage(jsonQuery: IJsonQuery): (villageId: number | undefined) => IJsonQuery {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  let nextJsonQuery = clone(jsonQuery);

  return villageId => {
    if (villageId && !isSuburban(offerType)) {
      nextJsonQuery = selectOfferType(nextJsonQuery)(EOfferType.House);
      nextJsonQuery = selectOfferType(nextJsonQuery)(EOfferType.HousePart);
      nextJsonQuery = selectOfferType(nextJsonQuery)(EOfferType.Townhouse);
      nextJsonQuery = selectOfferType(nextJsonQuery)(EOfferType.Land);
    }

    nextJsonQuery = setTerm('kp_id')(nextJsonQuery)(villageId);

    return nextJsonQuery;
  };
}
